import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuItem } from 'primeng/api/menuitem';
import { IDocumentTemplate } from '@ispm/test/components/documents-tab/interfaces/document-template.interface';

@Component({
  selector: 'gen-documents-actions',
  templateUrl: './documents-actions.component.html',
  styleUrls: ['./documents-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentsActionsComponent implements OnInit {

  @Input() documents: IDocumentTemplate[];
  @Input() completed: boolean = false;
  @Input() editingIsPermitted: boolean = true;
  @Input() showAddendumReportActions: boolean = false;
  @Input() showReleaseDocumentsMenu: boolean = false;
  @Input() showEditDocumentsButton: boolean = true;
  @Input() showPrintButton: boolean = true;
  @Input() enableGenerateAndDownloadButton: boolean = false;
  @Input() generateAndDownloadButtonText: string = "Generate";
  @Input() enableEditButton : boolean = false;
  @Input() toggleAction: boolean;

  private releaseButtonText: string = 'Release addendum report';
  private currentReportType: string = 'addendum';


  @Input() set reportType(value: string) {
      this.releaseButtonText = value == 'final' ? 'Release final report' : 'Release addendum report';
      this.currentReportType = value;
  }
  get reportType() {
     return this.currentReportType;
  }

  @Output() editingMode: EventEmitter<boolean> = new EventEmitter();
  @Output() selectedAction: EventEmitter<any> = new EventEmitter();
  @Output() releaseReport: EventEmitter<string> = new EventEmitter();
  @Output() generateAction: EventEmitter<any> = new EventEmitter();
  @Output() generateAndDownloadReport: EventEmitter<string> = new EventEmitter();

  private printItems: MenuItem[] = [];
  private generationItems: MenuItem[] = [];
  private editingStatus: boolean = false;

  constructor() { }

  ngOnInit() {
    // init print first item as a place holder
    this.documents.forEach(doc => {
      this.printItems.push({ label: 'Print ' + doc.title, command: (event) => this.onPrintSelectedItem(doc)});
      this.generationItems.push({ label: 'Generate ' + doc.title, command: (event) => this.onGenerateSelectedItem(doc)});
    });
  }

  onPrintSelectedItem(document: IDocumentTemplate) {
    console.log('Selected document for print:' + (document == null ? 'all' : document.title));
    this.selectedAction.emit(document);
  }

  onGenerateSelectedItem(document: IDocumentTemplate) {
    console.log('Selected document for generation:' + (document == null ? 'all' : document.title));
    this.generateAction.emit(document);
  }

  onEditing($event) {
    this.editingStatus = $event;
    this.editingMode.emit($event);
  }

  onReleaseReport() {
    this.releaseReport.emit(this.currentReportType);
  }

  onAddAndDownloadReport() {
    this.generateAndDownloadReport.emit(this.currentReportType);
  }

}
